var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ic-exclamation_svg__a",
    d: "M12 17a1 1 0 110 2 1 1 0 010-2zm0-11a1 1 0 01.993.883L13 7v7a1 1 0 01-1.993.117L11 14V7a1 1 0 011-1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-exclamation_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic-exclamation_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#1B87FD",
    xlinkHref: "#ic-exclamation_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#ic-exclamation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iZDR5M2w2dW0zYSIgZD0iTTEyIDE3Yy41NTIgMCAxIC40NDggMSAxcy0uNDQ4IDEtMSAxLTEtLjQ0OC0xLTEgLjQ0OC0xIDEtMXptMC0xMWMuNTEzIDAgLjkzNi4zODYuOTkzLjg4M0wxMyA3djdjMCAuNTUyLS40NDggMS0xIDEtLjUxMyAwLS45MzYtLjM4Ni0uOTkzLS44ODNMMTEgMTRWN2MwLS41NTIuNDQ4LTEgMS0xeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8Zz4KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU1MiAtMzQ3KSB0cmFuc2xhdGUoNTUyIDM0NykiPgogICAgICAgICAgICAgICAgPG1hc2sgaWQ9InN5c2cza2RqMGIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2Q0eTNsNnVtM2EiLz4KICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgIDx1c2UgZmlsbD0iIzFCODdGRCIgeGxpbms6aHJlZj0iI2Q0eTNsNnVtM2EiLz4KICAgICAgICAgICAgICAgIDxnIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjc3lzZzNrZGowYikiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDBIMjRWMjRIMHoiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIcExclamation as ReactComponent };